/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, Input, NgZone} from '@angular/core';
import {safeDetectChanges} from '../common/util/safe-detect-changes';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';
import * as _ from 'lodash';

import template from './copy-from-line-item.component.html';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';
import {SearchResource} from '../../components/api/resources/resource/search';

@Component({
  standalone: false,
  selector: 'adn-copy-from-line-item',
  template
})
export class CopyFromLineItemComponent {
  @Input() targeting: any;
  @Input() tabController: any;

  lineItem: any = {};
  lineItemResults: any[] = [];
  liTargeting: any = null;
  pending = false;
  initialised = false;

  readonly copyHook: any = {
    copy: (target: any) => {
      const copied = _.cloneDeep(this.liTargeting[target.targets]);
      if (_.isFunction(this.tabController?.copyTargetingTemplate)) {
        this.tabController.copyTargetingTemplate(
          target.widget,
          {data: {model: copied}},
          () => this.targeting[target.targets] = copied
        );
      } else {
        this.targeting[target.targets] = copied;
      }
      this.copyHook.results(target, true);
    }
  };

  readonly searchLineItems = (searchElement: any) => {
    this.searchResource.query({q: searchElement.search, types: 'LineItem'}).then((data: any) => {
      this.ngZone.run(() => {
        this.lineItemResults = data?.searchResults || [];
        safeDetectChanges(this.cdr);
      });
    }).catch(() => {
      this.ngZone.run(() => {
        this.lineItemResults = [];
        safeDetectChanges(this.cdr);
      });
    });
  };

  constructor(
    @Inject(SearchResource) private readonly searchResource: any,
    @Inject(LineItemResource) private readonly LineItem: any,
    private readonly ngZone: NgZone,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  lineItemSelected(): void {
    this.pending = true;
    this.initialised = true;
    if (_.isFunction(this.copyHook.clear)) {
      this.copyHook.clear();
    }
    this.LineItem.get({id: this.lineItem.id}, (results: any) => {
      deferMarkForCheck(this.cdr, () => {
        this.liTargeting = results.targeting;
        this.pending = false;
      });
    }, () => {
      deferMarkForCheck(this.cdr, () => {
        this.liTargeting = null;
        this.pending = false;
      });
    });
  }
}
